// extracted by mini-css-extract-plugin
export default {"norm-season":"NormSeason_norm-season__vLwDy","norm-season-text":"NormSeason_norm-season-text__Fci80","norm-season-dropdown":"NormSeason_norm-season-dropdown__9MHyl"};